import React from 'react';
import SpinnerCore from './Spinner';
import SpinnerFallback from './SpinnerFallback';
import ErrorBoundary from '../ErrorBoundary';

/**
 * This component variant was created because there has been occasional errors
 * reported that might have something to do with the use of CSSTransition in the
 * Spinner component.
 */
export default function Spinner(props) {
    return (
        <ErrorBoundary
            fallbackElement={<SpinnerFallback {...props} />}>
            <SpinnerCore {...props} />
        </ErrorBoundary>
    );
}